// extracted by mini-css-extract-plugin
export var animationContainer = "_nj-0";
export var footer = "_nj-1";
export var gray = "_nj-2";
export var lineItem = "_nj-3";
export var lineItemImage = "_nj-4";
export var lineItemInfo = "_nj-5";
export var lineItemText = "_nj-6";
export var lineItems = "_nj-7";
export var modalContent = "_nj-8";
export var options = "_nj-9";
export var orderName = "_nj-a";
export var refundAmount = "_nj-b";